import PropTypes from 'prop-types'
import {
  Box,
  Modal,
  ModalContent,
  ModalOverlay,
  Spinner,
} from '@chakra-ui/react'
import React from 'react'

export default function LoadingView({ open }) {
  return (
    <Modal isCentered isOpen={open} onClose={() => null}>
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
      <ModalContent bgColor="transparent" borderRadius={100} h="50px" w="50px">
        <Box h="50px" w="50px">
          <Spinner
            w="100%"
            h="100%"
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
          />
        </Box>
      </ModalContent>
    </Modal>
  )
}

LoadingView.propTypes = {
  open: PropTypes.bool,
}
